import { useEffect, useMemo, useState } from 'react';
import { useTopBarLeftContent } from './context/TopBarLeftContentContext';
import { useMobileFilter } from './context/MobileFilterContext';
import CollapsibleFilterGroup from './CollapsibleFilterGroup';
import MobileFilterDrawer from './ui/MobileFilterDrawer';
import { KANBAN_ESTADO_FILTER_OPTIONS } from '../utils/optimizationTransformers';

const PLATFORM_OPTIONS = [
  { value: 'todas', label: 'Todas' },
  { value: 'google', label: 'Google Ads' },
  { value: 'meta', label: 'Meta Ads' },
];

export default function OptimizacionesFilterBar({
  filtroPlataforma,
  setFiltroPlataforma,
  filtroEstatus,
  setFiltroEstatus,
}) {
  const { registerContent, clearContent } = useTopBarLeftContent();
  const { isMobileFilterOpen, closeMobileFilter } = useMobileFilter();
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1024);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const filtersContent = useMemo(() => {
    const isSmallScreen = windowWidth < 1024;

    if (isSmallScreen) {
      return null;
    }

    return (
    <div
      className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-xl p-3"
      data-testid="optimizaciones-sticky-filter"
    >
      <div className="flex flex-wrap items-center gap-3">
        <CollapsibleFilterGroup
          label="Plataforma"
          value={filtroPlataforma}
          options={PLATFORM_OPTIONS}
          onChange={setFiltroPlataforma}
        />
        <CollapsibleFilterGroup
          label="Estado"
          value={filtroEstatus}
          options={KANBAN_ESTADO_FILTER_OPTIONS}
          onChange={setFiltroEstatus}
        />
      </div>
    </div>
    );
  }, [windowWidth, filtroPlataforma, setFiltroPlataforma, filtroEstatus, setFiltroEstatus]);

  useEffect(() => {
    registerContent(filtersContent);
    return () => clearContent();
  }, [filtersContent, registerContent, clearContent]);

  const isSmallScreen = windowWidth < 1024;

  return (
    <>
      {isSmallScreen && (
        <MobileFilterDrawer
          isOpen={isMobileFilterOpen}
          onClose={closeMobileFilter}
          filters={[
            {
              key: 'platform',
              label: 'Plataforma',
              options: PLATFORM_OPTIONS,
            },
            {
              key: 'estado',
              label: 'Estado',
              options: KANBAN_ESTADO_FILTER_OPTIONS,
            },
          ]}
          selectedFilters={{
            platform: filtroPlataforma,
            estado: filtroEstatus,
          }}
          onFilterChange={(key, value) => {
            if (key === 'platform') setFiltroPlataforma(value);
            if (key === 'estado') setFiltroEstatus(value);
          }}
          darkMode={true}
        />
      )}
    </>
  );
}
